<template>
    <div class="prop-popup-box">
        <!-- 道具背景板 -->
        <div class="prop-popup-box-top">
          <img :src="prop?.img"/>
          <span>{{ prop?.name }}</span>
        </div>
        <div class="prop-popup-box-bottom">
          {{ prop?.desc }}
        </div>
    </div>
  </template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
  
export default {
  components: {},
  props: {
    prop: {
      type: Object,
      default: ()=>{
        return {}
      },
    },
  },

  setup(props, { emit }) {
    const { cur_kep, total_kep } = props;

    return {
      
    };
  },
};
</script>
  
<style lang="less" scoped>
    .prop-popup-box{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 199px;
      height: 101px;
      background-color: #fff;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      &-top{
        width: 100%;
        height: 39px;
        background: 
          radial-gradient(118.8% 82.2% at 50% 82.2%, #f1b76b 0%, #c07a53 100%),
          radial-gradient(118.8% 82.2% at 50% 82.2%, #d9ab6f 0%, #b67f60 100%);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 7px;
        box-sizing: border-box;
        img{
          width: 38px;
          height: 35px;
          margin-right: 8px;
        }
        span{
          color: #ffffff;
          font-size: 12px;
          font-weight: 600;
          font-family: "PingFang SC";
          text-align: left;
        }
      }
      &-bottom{
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 2px;
        color: #484c58;
        font-size: 12px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
</style>
  